import React from 'react'
import { SelectedValueReportingFacet } from '../../graphql/schema/types/value-reporting'
import { RemoteApp } from '../../legacy-design-system/remote-app/remote-app'
import { ServerlessAuth } from './serverless-auth'

export const remoteComponentID = 'contrast-serverless-remote-component'

export enum SERVERLESS_MODULES {
  ENTRY = './ServerlessEntry',
  VR_RATING_OVERVIEW = './ServerlessVrRatingOverviewEntry',
  CONTAINERS_ENTRY = './ContainersEntry'
}

export const SERVERLESS_BASE_NAME = {
  [SERVERLESS_MODULES.ENTRY]: 'serverless',
  [SERVERLESS_MODULES.CONTAINERS_ENTRY]: 'containers'
}

interface ServerlesProps {
  module?: SERVERLESS_MODULES
  selectedFacets?: SelectedValueReportingFacet[]
}

export function Serverless(props?: ServerlesProps) {
  const { module = SERVERLESS_MODULES.ENTRY, selectedFacets } = props || {}
  const baseName = SERVERLESS_BASE_NAME[module] ?? 'serverless'

  return (
    <ServerlessAuth>
      {({
        remoteEntry,
        accessToken,
        clientHost,
        role,
        organizationID,
        currentUserProfile
      }) => {
        return (
          <RemoteApp
            data-testid={remoteComponentID}
            module={module}
            scope="serverless_ui"
            src={remoteEntry}
            accessToken={accessToken}
            clientHost={clientHost}
            role={role}
            organizationId={organizationID}
            basename={`/${organizationID}/${baseName}`}
            currentUserProfile={currentUserProfile}
            selectedFacets={selectedFacets}
          />
        )
      }}
    </ServerlessAuth>
  )
}
